import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["hideOnNoad", "hideOnError", "onNoad", "onError", "render"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState } from 'react';
import { BuzzoolaBanner } from '../BuzzoolaBanner';
import { jsx as _jsx } from "react/jsx-runtime";
export const BuzzoolaBannerWithHide = _ref => {
  let {
      hideOnNoad,
      hideOnError,
      onNoad,
      onError,
      render
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const [hidden, setHidden] = useState(false);
  if (hidden) {
    return null;
  }
  const handleNoad = function () {
    if (hideOnNoad) {
      setHidden(true);
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    onNoad === null || onNoad === void 0 || onNoad(...args);
  };
  const handleError = function () {
    if (hideOnError) {
      setHidden(true);
    }
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    onError === null || onError === void 0 || onError(...args);
  };
  const banner = /*#__PURE__*/_jsx(BuzzoolaBanner, _objectSpread(_objectSpread({}, restProps), {}, {
    onError: handleError,
    onNoad: handleNoad
  }));
  return render ? render({
    children: banner
  }) : banner;
};